import script from "./BMap.vue?vue&type=script&setup=true&lang=js"
export * from "./BMap.vue?vue&type=script&setup=true&lang=js"

import "./BMap.vue?vue&type=style&index=0&id=90aa5908&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90aa5908"]])

export default __exports__